import { MobiDocument } from './MobiDocument';

export class ClasseScolaireEnseignantDocument extends MobiDocument{
    private _id : string;
    private _rev : string; 
    private classescolaire_id : number;
    private enseignant_id : number;

    constructor(classeScolaireEnseignant : any) {
        super();
        this._id = classeScolaireEnseignant._id;
        this._rev = classeScolaireEnseignant._rev;
        this.classescolaire_id = classeScolaireEnseignant.classescolaire_id;
        this.enseignant_id = classeScolaireEnseignant.enseignant_id
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getClassescolaire_id(): number {
        return this.classescolaire_id;
    }

    public setClassescolaire_id(classescolaire_id: number): void {
        this.classescolaire_id = classescolaire_id;
    }

    public getEnseignant_id(): number {
        return this.enseignant_id;
    }

    public setEnseignant_id(enseignant_id: number): void {
        this.enseignant_id = enseignant_id;
    }



}